import { createContext, useContext } from 'react';
import type { useAdminHttp, useAdminSession, useAdminToasts, useTenantContext } from '../hooks/index.js';

export interface AdminAppContextValue {
  session: ReturnType<typeof useAdminSession>;
  toasts: ReturnType<typeof useAdminToasts>;
  http: ReturnType<typeof useAdminHttp>;
  tenant: ReturnType<typeof useTenantContext>;
}

export const AdminAppContext = createContext<AdminAppContextValue | undefined>(undefined);

export function useAdminAppContext(): AdminAppContextValue {
  const context = useContext(AdminAppContext);
  if (!context) throw new Error('AdminAppContext provider is missing');
  return context;
}
